/**
 * description: 活动稿-新增场次

 */


//删除transconfirm
"use strict";
angular.module("personalLibraryActivityAddFieldModule", [])
    .controller('personalLibraryActivityAddFieldCtrl', ['$scope', '$filter', '$modalInstance', 'selectedDays', 'alreadySetFields', 'modalDialog', '$element', function($scope, $filter, $modalInstance, selectedDays, alreadySetFields, modalDialog, $element) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.status = {
                borderColor: '#39B88C',
                show: true,
            };
            $scope.data = {
                alreadySetFields: []
            };
            initSelectedDays();
            initAlreadySetFields();
            initColorIndex();
        }
        /**
         * [initColorIndex description] 初始化颜色值
         * @return {[type]} [description]
         */
        function initColorIndex() {
            if (!alreadySetFields[0] || alreadySetFields[0].colorIndex === undefined) {
                $scope.status.colorIndex = 0;
            } else {
                $scope.status.colorIndex = alreadySetFields[0].colorIndex === 7 ? 0 : alreadySetFields[0].colorIndex + 1
            }
        }
        /**
         * [getColorIndex description] 获取颜色序号
         * @return {[type]} [description]
         */
        function getColorIndex() {
            var index = $scope.status.colorIndex;
            if ($scope.status.colorIndex === 7) {
                $scope.status.colorIndex = 0;
            } else {
                $scope.status.colorIndex++;
            }
            return index;
        }
        /**
         * [deleteTime description] 删除选中日程
         * @param {object} [item] [description] 被选中的日程
         * @return {[type]} [description]
         */
        $scope.deleteTime = function(item) {
            for (var i in $scope.data.alreadySetFields) {
                var filed = $scope.data.alreadySetFields[i];
                if (JSON.stringify(filed.startEndTime) === JSON.stringify(item.startEndTime)) {
                    $scope.data.alreadySetFields.splice(i, 1);
                    break;
                }
            }
            for (var j in alreadySetFields) {
                var field = alreadySetFields[j];
                if (selectedDays.start === field.start && selectedDays.end === field.end && JSON.stringify(field.startEndTime) === JSON.stringify(item.startEndTime)) {
                    alreadySetFields.splice(j, 1);
                    break;
                }
            }
        };
        /**
         * [addTime description] 设置时间段
         */
        $scope.addTime = function() {
            if (!$scope.status.startEndTime) {
                modalDialog.success("请先选择时间段", "success", false, function() {}, function() {}, '', 'left0');
                return;
            }
            if (timeHasUsed()) {
                modalDialog.success("该时间段已经被添加过了", "success", false, function() {}, function() {}, '', 'left0');
                return;
            }
            var time = angular.copy(selectedDays);
            var colorIndex = getColorIndex();
            angular.extend(time, {
                colorIndex: colorIndex,
                className: "calendarColor" + colorIndex,
                content: "",
                allDay: false,
                startEndTime: angular.copy($scope.status.startEndTime),
                title: $scope.status.startEndTime[0] + "-" + $scope.status.startEndTime[1],
            });
            alreadySetFields.unshift(angular.copy(time));
            $scope.data.alreadySetFields.unshift(time);
            $scope.status.startEndTime = '';
        };
        /**
         * [timeHasUsed description] 时间是否已经被添加
         * @return {[type]} [description]
         */
        function timeHasUsed() {
            var flag = false;
            for (var i in $scope.data.alreadySetFields) {
                var field = $scope.data.alreadySetFields[i];
                if (JSON.stringify($scope.status.startEndTime) === JSON.stringify(field.startEndTime)) {
                    flag = true;
                    break;
                }
            }
            return flag;
        }
        /**
         * [initSelectedDays description] 初始化所选中的日期
         * @return {[type]} [description]
         */
        function initSelectedDays() {
            for (var i in selectedDays) {
                var date = selectedDays[i].date;
                selectedDays[i].date = new Date(Date.parse(date)) - 0;
            }
            selectedDays.sort(function(x, y) {
                return x.date - y.date;
            });
            var startDate = selectedDays[0].date;
            var endDate = selectedDays[selectedDays.length - 1].date + 1000 * 3600 * 24;
            selectedDays = {
                start: startDate,
                end: endDate,
                sdate: $filter("date")(startDate, "yyyy-MM-dd"),
                edate: $filter("date")(endDate, "yyyy-MM-dd"),
            };
        }
        /**
         * [initAlreadySetFields description] 初始化展示已选场次
         * @return {[type]} [description]
         */
        function initAlreadySetFields() {
            for (var i in alreadySetFields) {
                var filed = alreadySetFields[i];
                if (filed.start === selectedDays.start && filed.end === selectedDays.end) {
                    $scope.data.alreadySetFields.push(filed);
                }
            }
        }
        /**
         * [isConfirm description] 确定
         * @return {Boolean} [description]
         */
        $scope.isConfirm = function() {
            $modalInstance.close(angular.copy(alreadySetFields));
        };

        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

    }]);